export const Layer = {
  SingleSkin: 'singleSkin',
  Default: 'default',
  Hover: 'hover',
  Top: 'top',
};

export const Visible = {
  Default: 'default',
  Hover: 'hover',
  Always: 'always',
};

export const Skin = {
  None: 'none',
  Gradient: 'gradient',
  Dark: 'dark',
};

export const Placement = {
  TopStart: 'top-start',
  TopEnd: 'top-end',
  Middle: 'middle',
  BottomEnd: 'bottom-end',
  BottomStart: 'bottom-start',
};
